import { err, Result } from "neverthrow";
import { DomainError } from "@/lib/api/domain-error";
import type { RequestFn } from "@/lib/api/types";
import type {
  AccountPlanModel,
  AccountPlanSnapshotProps,
  AccountPlanType,
} from "./models";

const ACCOUNT_PLAN_ROUTE_V1 = "/v1/account-plans";
const ACCOUNT_PLAN_ROUTE_V1_PUBLIC = "/v1/public/account-plans";

export default class AccountPlanRepository {
  constructor(private readonly request: RequestFn) {}

  async getAllActive(
    planType?: AccountPlanType,
  ): Promise<Result<AccountPlanModel[], DomainError>> {
    try {
      const query = planType ? `?planType=${encodeURIComponent(planType)}` : "";
      const url = `${ACCOUNT_PLAN_ROUTE_V1_PUBLIC}/active${query}`;
      const apiResult = await this.request({
        url,
        method: "Get",
      });

      return apiResult.map((domainData) =>
        domainData.data.map((plan: AccountPlanModel) => {
          return {
            id: plan.id,
            name: plan.name,
            planType: plan.planType,
            order: plan.order,
            priceMonthly: plan.priceMonthly,
            priceYearly: plan.priceYearly,
            currency: plan.currency,
            description: plan.description,
            features: plan.features,
            availableAddons: plan.availableAddons ?? [],
          };
        }),
      );
    } catch (error) {
      return err(new DomainError(error));
    }
  }

  async getEffective(
    accountSlug: string,
  ): Promise<Result<AccountPlanSnapshotProps, DomainError>> {
    try {
      const url = `${ACCOUNT_PLAN_ROUTE_V1}/effective/${accountSlug}`;
      const apiResult = await this.request({
        url,
        method: "Get",
      });

      return apiResult.map(
        (domainData) => domainData.data as AccountPlanSnapshotProps,
      );
    } catch (error) {
      return err(new DomainError(error));
    }
  }

  // async create(
  //   name: string,
  //   contactEmail: string,
  // ): Promise<Result<void, DomainError>> {
  //   try {
  //     const url = `${ACCOUNT_PLAN_ROUTE_V1}`;
  //     const apiResult = await this.request({
  //       url,
  //       method: "Post",
  //       data: {
  //         name,
  //         contactEmail,
  //       },
  //     });

  //     return apiResult.map((domainData: any) => {
  //       return domainData.data;
  //     });
  //   } catch (error) {
  //     return err(new DomainError(error));
  //   }
  // }
}
